import { ANALYTIC_FEATURES } from 'constants/app.constant';
export var psRoutePrefix = {
    instructor: '/programSolution'
};
export var PS_EMERGE_LEARN_MORE_URL = 'https://www.elsevier.com/products/elsevier-360';
export var PS_PATHS = {
    homePage: "".concat(psRoutePrefix.instructor),
    courseSummaryPage: "".concat(psRoutePrefix.instructor, "/courseSummary"),
    studentProfile: "".concat(psRoutePrefix.instructor, "/studentProfile/:evolveUsername"),
    studentDashboard: "".concat(psRoutePrefix.instructor, "/studentDashboard")
};
export var PS_STUDENT_DASHBOARD_TABS = {
    hesiExams: {
        hash: '#hesiExams',
        name: 'HESI Exams',
        index: 0,
        trackAAEventName: ANALYTIC_FEATURES.PSD_STUDENT_DASHBOARD_HESI_EXAMS_TAB_CLICK
    },
    sherpathAssignments: {
        hash: '#sherpathAssignments',
        name: 'Sherpath Assignments',
        index: 1,
        trackAAEventName: ANALYTIC_FEATURES.PSD_STUDENT_DASHBOARD_SHERPATH_ASSIGNMENTS_TAB_CLICK
    },
    shadowHealthAssignments: {
        hash: '#shadowHealthAssignments',
        name: 'Shadow Health Assignments',
        index: 2,
        trackAAEventName: ANALYTIC_FEATURES.PSD_STUDENT_DASHBOARD_SHADOW_HEALTH_ASSIGNMENTS_TAB_CLICK
    },
    categoryPerformance: {
        hash: '#categoryPerformance',
        name: 'Category Performance',
        index: 3,
        trackAAEventName: ANALYTIC_FEATURES.PSD_STUDENT_DASHBOARD_CATEGORY_PERFORMANCE_TAB_CLICK
    },
    ngnItemTypeDetails: {
        hash: '#ngnItemTypeDetails',
        name: 'NGN Item Type Details',
        index: 4,
        trackAAEventName: ANALYTIC_FEATURES.PSD_STUDENT_DASHBOARD_NGN_ITEM_TYPE_DETAILS_TAB_CLICK
    }
};
export var PS_STUDENT_DASHBOARD_QUERY_KEY = 'psStudentDashboardSummary';
export var PS_STUDENT_PROFILE_TABS = {
    hesiExams: {
        hash: '#hesiExams',
        name: 'HESI Exams',
        index: 0,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_HESI_EXAMS_TAB_CLICK
    },
    sherpathAssignments: {
        hash: '#sherpathAssignments',
        name: 'Sherpath Assignments',
        index: 1,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_SHERPATH_ASSIGNMENTS_TAB_CLICK
    },
    shadowHealthAssignments: {
        hash: '#shadowHealthAssignments',
        name: 'Shadow Health Assignments',
        index: 2,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_SHADOW_HEALTH_ASSIGNMENTS_TAB_CLICK
    },
    categoryPerformance: {
        hash: '#categoryPerformance',
        name: 'Category Performance',
        index: 3,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_CATEGORY_PERFORMANCE_TAB_CLICK
    },
    eaqTopicPerformance: {
        hash: '#topicAreaPerformance',
        name: 'Topic Area Performance',
        index: 4,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_TOPIC_AREA_PERFORMANCE_TAB_CLICK
    },
    ngnDetails: {
        hash: '#ngnDetails',
        name: 'NGN Details',
        index: 5,
        trackAAEventName: ANALYTIC_FEATURES.PS_STUDENT_PROFILE_NGN_DETAILS_TAB_CLICK
    }
};
export var PS_STUDENT_PROFILE_TABS_MODAL = Object.values(PS_STUDENT_PROFILE_TABS);
export var TOPIC_AREA_TABS_DATA = {
    chapterMastery: { name: 'EAQ Topic Mastery', id: 'chapter-mastery' },
    hesiExamCategories: { name: 'HESI Exam Categories', id: 'hesi-exam-categories' },
    shadowHealthCategories: { name: 'Shadow Health Categories (Coming Soon)', id: 'shadow-health-categories' }
};
export var HESI_SCORE_TYPE = {
    likelyScore: 'likely-score',
    meanScore: 'mean-score'
};
export var hesiScoreOptions = [
    {
        key: HESI_SCORE_TYPE.likelyScore,
        name: 'Likely HESI Exit Score'
    },
    {
        key: HESI_SCORE_TYPE.meanScore,
        name: 'Mean HESI Exit Score'
    }
];
export var HESI_EXAMS_TABS_DATA = {
    examPerformance: { name: 'Exam Results', id: 'exam-performance' },
    hesiExitPredictions: { name: 'Monthly Trend', id: 'hesi-exit-predictions' }
};
export var RESOURCE_TYPES = {
    ADAPTIVE_LESSON: {
        id: 'ADAPTIVE_LESSON',
        displayName: 'Lesson'
    },
    SHERPATH_LESSON: {
        id: 'SHERPATH_LESSON',
        displayName: 'Lesson'
    },
    SHERPATH_SIMULATION: {
        id: 'SHERPATH_SIMULATION',
        displayName: 'Simulation'
    },
    SHERPATH_SKILL: {
        id: 'SHERPATH_SKILL',
        displayName: 'Skill'
    },
    SHADOW_HEALTH: {
        id: 'SHADOW_HEALTH',
        displayName: 'ShadowHealth'
    },
    OSMOSIS_VIDEO: {
        id: 'OSMOSIS_VIDEO',
        displayName: 'Osmosis'
    },
    REVIEW_QUIZ: {
        id: 'REVIEW_QUIZ',
        displayName: 'Interactive Review Questions'
    }
};
export var UNSUPPORTED_RESOURCE_TYPE = ['LMS', 'DOWNLOAD_BY_RESOURCE_TYPE', 'DOWNLOADS'];
export var MAX_RESOURCE_MASTERY_ITEMS_PER_PAGE = 5;
export var PS_COURSE_SUMMARY_TABS = {
    sherpath: {
        hash: '#sherpath',
        index: 0
    },
    shadowHealth: {
        hash: '#shadowHealth',
        index: 1
    },
    hesi: {
        hash: '#hesi',
        index: 2
    }
};
export var USE_FETCH_KEYS = {
    ACTIVE_CWCOURSES_COUNT: 'ACTIVE_CWCOURSES_COUNT',
    ACTIVE_SHCOURSES_COUNT: 'ACTIVE_SHCOURSES_COUNT',
    PROGRAM_MEAN_HESI_SCORE: 'PROGRAM_MEAN_HESI_SCORE',
    HESI_PROGRAMS: 'HESI_PROGRAMS',
    FETCH_PROGRAMS: 'FETCH_PROGRAMS',
    FETCH_PROGRAMS_ASSESS_REVIEW: 'FETCH_PROGRAMS_ASSESS_REVIEW',
    FETCH_COHORTS: 'FETCH_COHORTS',
    FETCH_SH_USER: 'FETCH_SH_USER'
};
export var COHORT_STALE_TIME = 1000 * 60;
export var CUSTOM_HESI_THRESHOLD_SCORE_KEY = 'customHesiThresholdScoreKey';
